import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { SubproductDefinition, SubproductDefinitionDTO, SubproductDefinitionDTO$reflection, SubproductDefinition$reflection } from "./Model.js";
import { bool_type, int32_type, list_type, record_type, class_type, string_type, lambda_type, unit_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { ProductModule_toTranslation, ProductModule_toInt, ProductModule_fromString, ProductModule_toString, ProductModule_getAllProducts, ProductModule_ofInt, Product$reflection } from "../../DomainTypes.js";
import { String100Module_create, String100$reflection } from "../../WrappedString.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { LoadState$2, SaveStatus, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { curry, uncurry, partialApply, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { InputType, lengthLTE, isOnlyNumbers } from "../../Validation/Common.js";
import { truncateWithEllipsis, Result_toBool } from "../../Utils.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { TextAreaProps$1, TextAreaProps$1_GetDefault, render as render_2 } from "../../Components/StatefulFormFields/TextArea.js";
import { ButtonKind, wrappedButton, ButtonProps, defaultProps } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { empty, ofArray, tryFind, map, singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/List.js";
import { map as map_1 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../../Components/Message/Message.js";
import { renderDotMenuAreaTable } from "../../Components/Table/Table.js";
import "../../../src/Containers/SubproductDefinition/View.scss";


class ModalType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CreateSubproductDefinition", "EditSubproductDefinition"];
    }
}

function ModalType$reflection() {
    return union_type("Containers.SubproductDefinition.View.ModalType", [], ModalType, () => [[["Item", SubproductDefinition$reflection()]], [["Item", SubproductDefinition$reflection()]]]);
}

class CreateOrEditModalProps extends Record {
    constructor(ModalType, CloseModalFn, ReloadSubproductDefinitions, SaveSubproductDefinition) {
        super();
        this.ModalType = ModalType;
        this.CloseModalFn = CloseModalFn;
        this.ReloadSubproductDefinitions = ReloadSubproductDefinitions;
        this.SaveSubproductDefinition = SaveSubproductDefinition;
    }
}

function CreateOrEditModalProps$reflection() {
    return record_type("Containers.SubproductDefinition.View.CreateOrEditModalProps", [], CreateOrEditModalProps, () => [["ModalType", ModalType$reflection()], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["ReloadSubproductDefinitions", lambda_type(unit_type, unit_type)], ["SaveSubproductDefinition", lambda_type(Product$reflection(), lambda_type(String100$reflection(), lambda_type(SubproductDefinitionDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))))]]);
}

const renderCreateOrEditModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, LabelText, inputRecord_1, LabelText_1, OptionValues, inputRecord_2, inputRecord_3, inputRecord_4, ValidationFn_1, arg_7;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    let subproductDefinition_1;
    const matchValue = props.ModalType;
    let pattern_matching_result, subproductDefinition;
    if (matchValue.tag === 1) {
        pattern_matching_result = 0;
        subproductDefinition = matchValue.fields[0];
    }
    else {
        pattern_matching_result = 0;
        subproductDefinition = matchValue.fields[0];
    }
    switch (pattern_matching_result) {
        case 0: {
            subproductDefinition_1 = subproductDefinition;
            break;
        }
    }
    const saveState = react.useState(new SaveStatus(0));
    const nameState = react.useState(subproductDefinition_1.DTO.Name);
    const typeOfSubproductState = react.useState(subproductDefinition_1.DTO.TypeOfSubproduct);
    const parameterState = react.useState(subproductDefinition_1.DTO.Parameter);
    const sortOrderState = react.useState(int32ToString(subproductDefinition_1.DTO.SortOrder));
    const productState = react.useState(ProductModule_ofInt(subproductDefinition_1.DTO.ProductNr));
    const sortOrderValidationFn = isOnlyNumbers;
    const nameValidationFn = (str_1) => lengthLTE(getTranslation, 100, new InputType(2), str_1);
    const inputFieldsAreValid = Result_toBool(sortOrderValidationFn(getTranslation, sortOrderState[0])) && Result_toBool(nameValidationFn(nameState[0]));
    let bodyHtml;
    const nameInputHtml = render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = getTranslation("Common.Name"), new TextProps$1(nameState[0], inputRecord.Type, inputRecord.Classes, (e) => {
        const arg = Browser_Types_Event__Event_get_Value(e);
        nameState[1](arg);
    }, inputRecord.Disabled, LabelText, "subproduct-definition-modal-name", nameValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))));
    const productInputHtml = selectOption((inputRecord_1 = SelectOption_get_getDefault(), (LabelText_1 = getTranslation("Common.Product"), (OptionValues = ProductModule_getAllProducts(getTranslation), new SelectOption(new ValueProp(0, ProductModule_toString(productState[0]), (e_1) => {
        const arg_1 = ProductModule_fromString(Browser_Types_Event__Event_get_Value(e_1));
        productState[1](arg_1);
    }), "subproduct-definition-modal-product", OptionValues, inputRecord_1.Classes, LabelText_1, inputRecord_1.Disabled, inputRecord_1.HTMLProps)))));
    const typeOfSubproductHtml = render_1()((inputRecord_2 = TextProps$1_GetDefault(), new TextProps$1(typeOfSubproductState[0], inputRecord_2.Type, inputRecord_2.Classes, (e_2) => {
        const arg_2 = Browser_Types_Event__Event_get_Value(e_2);
        typeOfSubproductState[1](arg_2);
    }, inputRecord_2.Disabled, "TypeOfSubproduct", "subproduct-definition-modal-type-of-subproduct", inputRecord_2.ValidationFn, inputRecord_2.DynamicWidth, inputRecord_2.HTMLProps, inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, inputRecord_2.Name)));
    const parameterInputHtml = render_2()((inputRecord_3 = TextAreaProps$1_GetDefault(), new TextAreaProps$1(parameterState[0], inputRecord_3.Classes, (e_3) => {
        const arg_3 = Browser_Types_Event__Event_get_Value(e_3);
        parameterState[1](arg_3);
    }, inputRecord_3.Disabled, "Parameter", "subproduct-definition-modal-parameter", inputRecord_3.ValidationFn, inputRecord_3.DynamicWidth, inputRecord_3.HTMLProps, inputRecord_3.OnBlur, inputRecord_3.OnFocus, inputRecord_3.AutoComplete, inputRecord_3.Rows)));
    const sortOrderInputHtml = render_1()((inputRecord_4 = TextProps$1_GetDefault(), (ValidationFn_1 = partialApply(1, sortOrderValidationFn, [getTranslation]), new TextProps$1(sortOrderState[0], "number", inputRecord_4.Classes, (e_4) => {
        const arg_4 = Browser_Types_Event__Event_get_Value(e_4);
        sortOrderState[1](arg_4);
    }, inputRecord_4.Disabled, "SortOrder", "subproduct-definition-modal-sort-order", ValidationFn_1, inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name))));
    bodyHtml = react.createElement("div", {
        className: "subproduct-definition__edit-modal",
    }, nameInputHtml, productInputHtml, typeOfSubproductHtml, parameterInputHtml, sortOrderInputHtml);
    const cancelButtonProps = new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_5) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, "subproduct-definition-modal-cancel", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const acceptButtonProps = new ButtonProps(getTranslation("Common.Save"), defaultProps.Content, (_arg_6) => {
        let saveDTO;
        startImmediate((saveDTO = (new SubproductDefinitionDTO(nameState[0], ProductModule_toInt(productState[0]), typeOfSubproductState[0], parameterState[0], parse(sortOrderState[0], 511, false, 32))), (saveState[1](new SaveStatus(1)), singleton.Delay(() => {
            const matchValue_1 = String100Module_create(saveDTO.Name);
            if (matchValue_1.tag === 0) {
                return singleton.Bind(props.SaveSubproductDefinition(productState[0], matchValue_1.fields[0], saveDTO), (_arg) => {
                    const result = _arg;
                    if (result.tag === 0) {
                        saveState[1](new SaveStatus(2));
                        return singleton.Zero();
                    }
                    else {
                        saveState[1](new SaveStatus(3, result.fields[0]));
                        return singleton.Zero();
                    }
                });
            }
            else {
                saveState[1](new SaveStatus(3, matchValue_1.fields[0]));
                return singleton.Zero();
            }
        }))));
    }, !inputFieldsAreValid, "subproduct-definition-modal-accept", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const actionTranslation = (props.ModalType.tag === 0) ? getTranslation("Common.Create") : getTranslation("Common.Edit");
    return renderAsModalThenSaveState(true, new ModalSize(2), toText(printf("%s Subproduct Definition"))(actionTranslation), bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Close"), (_arg_7) => {
        props.ReloadSubproductDefinitions();
        props.CloseModalFn();
    }, singleton_1([(arg_7 = getTranslation("Common.Saving"), toText(printf("%s Subproduct Definition"))(arg_7)), saveState[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderCreateOrEditModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SubproductDefinition\\View.fs", 182);

export class SubproductDefinitionProps extends Record {
    constructor(LoadSubproductDefinitions, SaveSubproductDefinition, CreateNewSubproductDefinition, DeleteSubproductDefinition, IsAdmin) {
        super();
        this.LoadSubproductDefinitions = LoadSubproductDefinitions;
        this.SaveSubproductDefinition = SaveSubproductDefinition;
        this.CreateNewSubproductDefinition = CreateNewSubproductDefinition;
        this.DeleteSubproductDefinition = DeleteSubproductDefinition;
        this.IsAdmin = IsAdmin;
    }
}

export function SubproductDefinitionProps$reflection() {
    return record_type("Containers.SubproductDefinition.View.SubproductDefinitionProps", [], SubproductDefinitionProps, () => [["LoadSubproductDefinitions", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(SubproductDefinitionDTO$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(SubproductDefinitionDTO$reflection())]], [["ErrorValue", string_type]]])]))], ["SaveSubproductDefinition", lambda_type(Product$reflection(), lambda_type(String100$reflection(), lambda_type(SubproductDefinitionDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))))], ["CreateNewSubproductDefinition", lambda_type(SubproductDefinitionDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["DeleteSubproductDefinition", lambda_type(string_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])])))], ["IsAdmin", bool_type]]);
}

export const renderSubproductDefinitions = FunctionComponent_Of_Z5A158BBF((props) => {
    let arg_12;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const subproductDefinitionsState = react.useState(new LoadState$2(0));
    const createOrEditModalState = react.useState(void 0);
    const deleteModalState = react.useState(void 0);
    const deleteSaveState = react.useState(new SaveStatus(0));
    const loadSubproductDefinitions = () => {
        subproductDefinitionsState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(props.LoadSubproductDefinitions(), (_arg) => {
            const result = _arg;
            const arg_1 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, map((s) => (new SubproductDefinition(s.Name + int32ToString(s.ProductNr), s)), result.fields[0])));
            subproductDefinitionsState[1](arg_1);
            return singleton.Zero();
        })));
    };
    react.useEffect(loadSubproductDefinitions, []);
    let dotMenu;
    const matchValue = subproductDefinitionsState[0];
    if (matchValue.tag === 2) {
        const subproductDefinitions_1 = matchValue.fields[0];
        dotMenu = ofArray([[getTranslation("Common.Edit"), (rowId) => {
            const arg_8 = map_1((arg_7) => (new ModalType(1, arg_7)), tryFind((s_9) => (s_9.Id === rowId), subproductDefinitions_1));
            createOrEditModalState[1](arg_8);
        }], [getTranslation("Common.Remove"), (rowId_1) => {
            const arg_9 = tryFind((s_10) => (s_10.Id === rowId_1), subproductDefinitions_1);
            deleteModalState[1](arg_9);
        }]]);
    }
    else {
        dotMenu = empty();
    }
    let editableTableHtml;
    const matchValue_1 = subproductDefinitionsState[0];
    switch (matchValue_1.tag) {
        case 1: {
            editableTableHtml = dotsLoading;
            break;
        }
        case 3: {
            editableTableHtml = error(matchValue_1.fields[0].split(""));
            break;
        }
        case 2: {
            editableTableHtml = renderDotMenuAreaTable(ofArray(["Name", "ProductNr", "TypeOfSubproduct", "Parameter", "SortOrder"]), map((subproductDefinition) => {
                const dto = subproductDefinition.DTO;
                const productTranslation = ProductModule_toTranslation(getTranslation, ProductModule_ofInt(dto.ProductNr));
                return [ofArray([dto.Name, toText(printf("%s (%i)"))(productTranslation)(dto.ProductNr), dto.TypeOfSubproduct, truncateWithEllipsis(20, dto.Parameter), int32ToString(dto.SortOrder)]), subproductDefinition.Id];
            }, matchValue_1.fields[0]), (_arg_4) => dotMenu, void 0, void 0, (value_1) => {
            });
            break;
        }
        default: {
            editableTableHtml = react.createElement(react.Fragment, {});
        }
    }
    let deleteModalHtml;
    const matchValue_2 = deleteModalState[0];
    if (matchValue_2 != null) {
        const subproductDefinition_1 = matchValue_2;
        let headerStr;
        const arg_10 = getTranslation("Common.Remove");
        headerStr = toText(printf("%s %s"))(arg_10)("Subproduct Definition");
        const closeModalFn = (_arg_5) => {
            deleteModalState[1](void 0);
        };
        deleteModalHtml = renderAsModalThenSaveState(true, new ModalSize(0), headerStr, (arg_12 = getTranslation("Common.Remove"), toText(printf("%s \"%s\"?"))(arg_12)(subproductDefinition_1.DTO.Name)), new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, closeModalFn, defaultProps.Disabled, "delete-subproduct-definition-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), new ButtonProps(getTranslation("Common.Remove"), defaultProps.Content, (_arg_6) => {
            const sd = subproductDefinition_1;
            deleteSaveState[1](new SaveStatus(1));
            startImmediate(singleton.Delay(() => singleton.Bind(props.DeleteSubproductDefinition(sd.DTO.Name, sd.DTO.ProductNr), (_arg_1) => {
                const result_1 = _arg_1;
                const arg_3 = (result_1.tag === 0) ? (new SaveStatus(2)) : (new SaveStatus(3, result_1.fields[0]));
                deleteSaveState[1](arg_3);
                return singleton.Zero();
            })));
        }, defaultProps.Disabled, "delete-subproduct-definition-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), getTranslation("Common.Close"), (_arg_7) => {
            loadSubproductDefinitions();
            closeModalFn();
        }, singleton_1([headerStr, deleteSaveState[0]]));
    }
    else {
        deleteModalHtml = react.createElement(react.Fragment, {});
    }
    let createOrEditModalHtml;
    const matchValue_3 = createOrEditModalState[0];
    if (matchValue_3 != null) {
        const modalType = matchValue_3;
        createOrEditModalHtml = renderCreateOrEditModal(new CreateOrEditModalProps(modalType, () => {
            createOrEditModalState[1](void 0);
        }, loadSubproductDefinitions, uncurry(3, (modalType.tag === 0) ? ((product) => ((string100) => ((dto_1) => props.CreateNewSubproductDefinition(dto_1)))) : curry(3, props.SaveSubproductDefinition))));
    }
    else {
        createOrEditModalHtml = react.createElement(react.Fragment, {});
    }
    const createNewSubproductDefinitionButtonHtml = props.IsAdmin ? wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.CreateNew"), defaultProps.Content, (_arg_8) => {
        const arg_16 = new ModalType(0, new SubproductDefinition("", new SubproductDefinitionDTO("", 0, "", "", 0)));
        createOrEditModalState[1](arg_16);
    }, defaultProps.Disabled, "subproduct-definition-create-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : react.createElement(react.Fragment, {});
    const children_8 = [react.createElement("h2", {}, "Subproduct Definitions"), createNewSubproductDefinitionButtonHtml, react.createElement("div", {
        className: "subproduct-definition__table",
    }, editableTableHtml), createOrEditModalHtml, deleteModalHtml];
    return react.createElement("div", {
        className: "subproduct-definition",
    }, ...children_8);
}, void 0, uncurry(2, void 0), void 0, "renderSubproductDefinitions", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SubproductDefinition\\View.fs", 376);

